export default __webpack_public_path__ + "static/nanits-43e7368bb8f175668896be2e5262acd0.jpg";